import { render, staticRenderFns } from "./TarefaOpcaoTratativaAssociacaoPage.vue?vue&type=template&id=39ac2abc"
import script from "./TarefaOpcaoTratativaAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./TarefaOpcaoTratativaAssociacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports